import { useRouter } from 'next/router';
import { useQuery } from 'react-query';

import auth from '@udacity/ureact-hoth';

import { publicEnv } from '~/features/environment/public';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { CatalogSearchResults, catalogSearchResultsSchema } from '../models/catalog-search-result';

export function useCanAccessLearningPlans() {
  const jwt = auth.getJWT();
  const router = useRouter();
  const companySlug = router.query.companySlug as string | undefined;
  const { data: catalogSearchResultsItems } = useQuery<CatalogSearchResults>(
    ['catalog', 'can-access-learning-plans'],
    async () => {
      const data = {
        page: 0,
        pageSize: 1,
        semanticTypes: ['Learning_Plan'],
        companySlug,
        allowEnterpriseLPs: true,
        sortLPs: true,
        enrolledOnly: false,
      };

      return await queryUdacityService({
        url: publicEnv.NEXT_PUBLIC_UNIFIED_CATALOG_URL,
        zodSchema: catalogSearchResultsSchema,
        body: JSON.stringify(data),
        authorization: jwt ? `Bearer ${jwt}` : undefined,
      });
    },
    {
      enabled: Boolean(companySlug),
    }
  );

  return (catalogSearchResultsItems?.numberOfHits || 0) > 0;
}
